import React from 'react'

import {
  bindTargetMixin,
  CancelButton,
  SaveButton,
  SelectInput
} from '../../../shared/FormBuilder'

const style = {
  form: {
    marginTop: '15px',
    paddingTop: '15px'
  },
  selectStyle: {
    maxWidth: '100%',
    width: '100%'
  }
}

const KarnofskyScale = [
  {
    label: '100: Normal no complaints; no evidence of disease.',
    code: '100: Normal no complaints; no evidence of disease.',
    level: 1
  },
  {
    label:
      '90: Able to carry on normal activity; minor signs or symptoms of disease.',
    code: '90: Able to carry on normal activity; minor signs or symptoms of disease.',
    level: 1
  },
  {
    label:
      '80: Normal activity with effort; some signs or symptoms of disease.',
    code: '80: Normal activity with effort; some signs or symptoms of disease.',
    level: 1
  },
  {
    label:
      '70: Cares for self; unable to carry on normal activity or to do active work.',
    code: '70: Cares for self; unable to carry on normal activity or to do active work.',
    level: 1
  },
  {
    label:
      '60: Requires occasional assistance, but is able to care for most of his personal needs.',
    code: '60: Requires occasional assistance, but is able to care for most of his personal needs.',
    level: 1
  },
  {
    label: '50: Requires considerable assistance and frequent medical care.',
    code: '50: Requires considerable assistance and frequent medical care.',
    level: 1
  },
  {
    label: '40: Disabled; requires special care and assistance.',
    code: '40: Disabled; requires special care and assistance.',
    level: 1
  },
  {
    label:
      '30: Severely disabled; hospital admission is indicated although death not imminent.',
    code: '30: Severely disabled; hospital admission is indicated although death not imminent.',
    level: 1
  },
  {
    label:
      '20: Very sick; hospital admission necessary; active supportive treatment necessary.',
    code: '20: Very sick; hospital admission necessary; active supportive treatment necessary.',
    level: 1
  },
  {
    label: '10: Moribund; fatal processes progressing rapidly.',
    code: '10: Moribund; fatal processes progressing rapidly.',
    level: 1
  },
  {
    label: '0: Dead.',
    code: '0: Dead.',
    level: 2
  }
]

class PalliativePerformanceForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: props.initialValues
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getValues = this.getValues.bind(this)
  }

  handleSubmit () {
    const { onSubmit } = this.props
    onSubmit(this.getValues())
  }

  getValues () {
    return { ...this.state.value }
  }

  render () {
    return (
      <form style={style.form}>
        <div className='row palliative-performance'>
          <div className='col-xs-12'>
            <SelectInput
              name='karnofskyPalliativePerformance'
              noSort
              options={KarnofskyScale}
              label='Karnofsky Palliative Performance Scale'
            />
          </div>
        </div>

        <div className='row end-xs margin-top nh-form-margin-top'>
          <div className='col-xs-12'>
            <CancelButton
              formKey={this.props.formKey}
              onClick={this.props.cancel}
            />

            <SaveButton
              formKey={this.props.formKey}
              disabled={this.props.pristine}
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </form>
    )
  }
}

export default PalliativePerformanceForm
